import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ErrorMessageComponent } from 'app/shared/error-message/error-message.component';

@Component({
    selector: 'app-login-failed',
    templateUrl: './login-failed.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ErrorMessageComponent],
})
export class LoginFailedComponent {
    readonly errorMessage = history.state?.message ?? 'Please try again later.';
}
